export default __webpack_public_path__ + "static/media/4.79113352.png";